phina.namespace(function() {

  phina.define("ps.EffectLayer", {
    superClass: "phina.display.CanvasElement",

    init: function() {
      this.superInit();
    }
  });

});
